import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,{attrs:{"items":_vm.items,"label":_vm.$t('monitoring.date.today') + ' vs.',"hide-details":true},model:{value:(_vm.select),callback:function ($$v) {_vm.select=$$v},expression:"select"}})}
var staticRenderFns = []

export { render, staticRenderFns }